'use client';

export default function Quote(Prop: {moduleOption: any}) {
  const {moduleOption} = Prop;
  const {quote, author} = moduleOption || {};
  return (
    <div className="home-quote">
      <div
        className="text-[22px] font-[600] italic leading-[1.36] mb-[35px]"
        dangerouslySetInnerHTML={{__html: quote}}
      ></div>
      <p className="text-[#e22319] mt-2 font-[600]">{author}</p>
    </div>
  );
}
